module.exports = __webpack_public_path__ + "img/symbol_7.e540abb9.png";